(() => {
  "use strict";

  const CLOCK_ID = "kaillos-clock";
  const STYLE_ID = "kaillos-clock-style";
  const TIME_SCALE = 1;

  // 変更箇所：Liquidから渡された画像パス（window.clockImagePaths）を使用する。
  const IMAGE_PATHS = window.clockImagePaths || {
    hour: "hour.webp",
    minute: "minute.webp",
    second: "second.webp"
  };

  const HAND_SETTINGS = {
    hour: {
      step: 1 / 120,
      amp: 0.15,
      freq: 7,
      decay: 16,
      // 最大280px (400pxの70%) かつ、コンテナ高の35%で可変
      heightStyle: { height: "35%", maxHeight: "280px" },
      imageTransform: "translate(-50%, -90.4%)"
    },
    minute: {
      step: 0.1,
      amp: 0.4,
      freq: 7,
      decay: 16,
      // 最大400px (一番長い針) かつ、コンテナ高の50%で可変
      heightStyle: { height: "50%", maxHeight: "400px" },
      imageTransform: "translate(-60%, -90.8%)"
    },
    second: {
      step: 6,
      amp: 1.2,
      freq: 7,
      decay: 16,
      // 最大320px (400pxの80%) かつ、コンテナ高の40%で可変
      heightStyle: { height: "40%", maxHeight: "320px" },
      imageTransform: "translate(-20%, -92.7%)"
    }
  };

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
      #${CLOCK_ID} {
        position: absolute;
        top: 40px;
        right: 20px;
        margin: 0 auto;
        width: 100%;
        max-width: 400px;
        aspect-ratio: 1 / 1;
        z-index: -1;
      }
        
      #${CLOCK_ID} .kaillos-clock-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
      }

      #${CLOCK_ID} .kaillos-clock-hand {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        transform: rotate(0deg);
      }

      #${CLOCK_ID} .kaillos-clock-hand img {
        display: block;
        position: absolute;
        left: 50%;
        top: 50%;
        width: auto;
      }

      @media (max-width: 750px) {
        #${CLOCK_ID} {
          top: 80px;
          right: -100px;
          max-width: 660px;
        }
        #${CLOCK_ID} .kaillos-clock-hour img { max-height: 462px !important; }
        #${CLOCK_ID} .kaillos-clock-minute img { max-height: 660px !important; }
        #${CLOCK_ID} .kaillos-clock-second img { max-height: 528px !important; }
      }
    `;

    document.head.appendChild(style);
  }

  function createClock() {
    const existingClock = document.getElementById(CLOCK_ID);
    if (existingClock) existingClock.remove();

    const clock = document.createElement("div");
    clock.id = CLOCK_ID;

    // wrapper 要素の作成
    const wrapper = document.createElement("div");
    wrapper.className = "kaillos-clock-wrapper";

    const hands = {};

    for (const [name, settings] of Object.entries(HAND_SETTINGS)) {
      const element = document.createElement("div");
      element.className = `kaillos-clock-hand kaillos-clock-${name}`;

      const image = document.createElement("img");
      image.src = IMAGE_PATHS[name];
      image.alt = "";
      image.draggable = false;
      image.style.height = settings.heightStyle.height;
      image.style.maxHeight = settings.heightStyle.maxHeight;
      image.style.transform = settings.imageTransform;

      element.appendChild(image);
      
      // clock 直接ではなく wrapper の配下に要素を追加
      wrapper.appendChild(element);

      hands[name] = {
        element,
        ...settings
      };
    }

    // wrapper を clock に追加
    clock.appendChild(wrapper);

    // 変更: #footer_inner を取得してそこに追加する（見つからない場合は body に追加）
    const targetContainer = document.getElementById("footer_inner") || document.body;
    targetContainer.appendChild(clock);

    return hands;
  }

  function getCurrentTimeSeconds() {
    const now = new Date();

    return (
      now.getHours() * 3600 +
      now.getMinutes() * 60 +
      now.getSeconds() +
      now.getMilliseconds() / 1000
    );
  }

  function startClock() {
    addStyles();

    const hands = createClock();
    const clockBaseSeconds = getCurrentTimeSeconds();
    const clockStartTime = performance.now();

    function animate(currentTime) {
      const elapsed = (currentTime - clockStartTime) / 1000;
      const clockTime = clockBaseSeconds + elapsed * TIME_SCALE;
      const tick = Math.floor(clockTime);
      const t = clockTime - tick;

      for (const hand of Object.values(hands)) {
        const baseRotation = tick * hand.step;
        const bounce =
          hand.amp *
          Math.sin(hand.freq * t * Math.PI) *
          Math.exp(-hand.decay * t);

        hand.element.style.transform =
          `rotate(${baseRotation + bounce}deg)`;
      }

      requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startClock, { once: true });
  } else {
    startClock();
  }
})();